import React from 'react';
import { FeatureExplanationDataSlotBlock } from '@models/feature-explanation';
import { ColoredExplanationBlock } from './ColoredExplanationBlock';

export const DataSlotExplanationBlock: React.FC<
  FeatureExplanationDataSlotBlock
> = block => (
  <ColoredExplanationBlock block={block}>
    {block.dataSlotName}
  </ColoredExplanationBlock>
);
